<template>
  <div>
    <!-- 操作按钮组 -->
    <div class="el_div">
      <el-button
      type="primary"
      size="mini"
      @click="draggable_true"
      v-if="btn_permission.includes('middle:warehousePoint:location')||btn_permission.includes('superAdmin')"
      >激活移动</el-button>
      <el-button
      type="primary"
      size="mini"
      @click="draggable_false"
      v-if="btn_permission.includes('middle:warehousePoint:location')||btn_permission.includes('superAdmin')"
      >保存节点</el-button>
      <!-- <el-button
      type="primary"
      size="mini"
      @click="auto_scroll"
      >{{scroll_flag}}</el-button> -->
    </div>
    <!-- 温度数据可视化 -->
    <div id="data-view">
      <div id="scroll-board">
        <!-- <el-tabs
        @tab-click="cut_tabs"
        v-model="JSON.stringify(active_name)"
        tab-position="left"
        type="border-card">
          <el-tab-pane name="1" style="overflow-x: auto;">
            <img slot="label" src="../../assets/cold_a.png" />
          </el-tab-pane>
          <el-tab-pane name="2" style="overflow-x: auto;">
            <img slot="label" src="../../assets/cold_b.png" />
          </el-tab-pane>
          <el-tab-pane name="3">
            <img slot="label" src="../../assets/cold_c.png" />
          </el-tab-pane>
        </el-tabs> -->
        <!-- 区域温控点 -->
        <div
        ref="pointArea1"
        class="pointArea">
          <img :src="row_now.imageUrl+'?auth_token='+upload_token"/>
          <div
          v-drag="{id:item.id,flag:flag}"
          class="drag_div"
          v-for="(item,index) in temp_data"
          :style="{left:item.xpercent,top:item.ypercent}"
          :title="item.pointName"
          >
            <!-- <el-popover
            placement="top"
            title="温控点详情"
            width="200"
            trigger='hover'
            >
              <span>温控点区域名称：{{item.pointAreaName}}</span><br>
              <span>温度：<span :class="item.normal?'':'change_red'">{{item.data}}℃</span></span><br>
              <span>温控点名称：{{item.pointName}}</span>
            </el-popover> -->
            <el-button
            :class="flag==true?'drag_move':''"
            size="mini"
            slot="reference">
              <span v-if="item.pointTypeText=='温度计'" class="iconfont icon-wendu">{{item.pointName}}</span>
              <span v-if="item.pointTypeText=='湿度计'" class="iconfont icon-shidu">{{item.pointName}}</span>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bind } from 'file-loader'
  export default {
    name:'check_plan',
    data() {
      return{
        upload_token:localStorage.getItem(localStorage.getItem('userName')+'token'),
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        //传值
        row_now:{},
        //是否可拖拽
        flag:false,
        //区域温控点列表
        temp_data:[],
        //节点数组
        node_list:[],
        //温控点提示信息
        temp_tool:'',
        //标签页初始值
        active_name:1,
        //轮播按钮
        scroll_flag:'开始轮播',
        scroll_status:true,
        //定时器默认值
        plan_check:null,
        //当前温控点
        now_drag:''
      }
    },
    //自定义指令
    directives: {
      drag(el,binding,vnode) {
        let oDiv = el // 当前元素
        // let self = this // 上下文
        // 禁止选择网页上的文字
        document.onselectstart = function () {
          return false
        }
        oDiv.onmousedown = function (e) {
          if(binding.value.flag==false){
            return false
          }
          // 鼠标按下，计算当前元素距离可视区的距离
          let disX = e.clientX - oDiv.offsetLeft
          let disY = e.clientY - oDiv.offsetTop
          let l=0
          let t=0
          vnode.context.node_list=[]
          document.onmousemove = function (e) {
            // oDiv.style.pointerEvents='none'
            // 通过事件委托，计算移动的距离
            l = e.clientX - disX
            t = e.clientY - disY
            if(l<0){
              l=0
            }
            if(l>document.querySelector('.pointArea').offsetWidth-113){
              l=document.querySelector('.pointArea').offsetWidth-113
            }
            if(t<0){
              t=0
            }
            if(t>document.querySelector('.pointArea').offsetHeight-33){
              t=document.querySelector('.pointArea').offsetHeight-33
            }
            // 移动当前元素
            oDiv.style.left = vnode.context.calculateLeft(document.querySelector('.pointArea').offsetWidth,l)
            oDiv.style.top = vnode.context.calculateTop(document.querySelector('.pointArea').offsetHeight,t)
          }
          document.onmouseup = function (e) {
            // oDiv.style.pointerEvents=null
            vnode.context.temp_data.forEach(item=>{
              if(item.id==binding.value.id){
                vnode.context.$set(item,'xpercent',oDiv.style.left)
                vnode.context.$set(item,'ypercent',oDiv.style.top)
              }
              vnode.context.node_list.push({
                id:item.id,
                xpercent:item.xpercent,
                ypercent:item.ypercent
              })
            })
            document.onmousemove = null
            document.onmouseup = null
          }
          // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
          return false
        }
      }
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      that.row_now=that.$route.query.row
      //获取区域温控点列表
      that.get_temp_list()
    },
    mounted() {

    },
    watch:{
      '$route'(to,from){
        if(to.name=='check_plan'){
          //获取区域温控点列表
          this.get_temp_list()
        }
      }
    },
    beforeDestroy() {
      clearInterval(this.plan_check)
    },
    methods:{
      //获取区域温控点列表
      get_temp_list(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehousePoint/pointBaseByArea/'+that.row_now.areaId
        }).then(data=>{
          if(data.data.success==true){
            that.temp_data=data.data.data
            that.flag=false
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //激活移动
      draggable_true(){
        this.flag=true
        this.$message.success('现在可以移动节点！')
      },
      //保存节点
      draggable_false(){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'put',
            url:that.publicAjax.extra_path+'/middle/warehousePoint/location',
            headers:{
              "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
              "content-type":"application/json;charset=UTF-8"
            },
            data:that.node_list
          }).then(data=>{
            if(data.data.success==true){
              that.$message.success(data.data.message)
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //自动滚动tab标签页
      auto_scroll(){
        if(this.scroll_status==true){
          this.scroll_status=false
          this.scroll_flag='停止轮播'
          this.plan_check=setInterval(()=>{
            this.cut_tabs()
          },5000)
        }else{
          this.scroll_status=true
          this.scroll_flag='开始轮播'
          clearInterval(this.plan_check)
        }
      },
      //切换tab事件
      cut_tabs(tab,event){
        this.flag=false
        if(event!=undefined){
          this.active_name=JSON.parse(tab.name)
          this.scroll_status=true
          this.scroll_flag='开始轮播'
          clearInterval(this.plan_check)
        }else{
          this.active_name++
          if(this.active_name==4){
            this.active_name=1
          }
        }
      },
      //获取温控点数据
      check_temp(item){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehousePoint/pointData/'+item.pointId
        }).then(data=>{
          if(data.data.success==true){

          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      calculateLeft(dom, left) {
          return this.toPercent(left / dom);
      },
      calculateTop(dom, top) {
          return this.toPercent(top / dom);
      },
      toPercent(point) {
          if (point == 0) {
              return 0;
          }
          return parseFloat(point * 100) + "%";
      }
    }
  }
</script>

<style scoped="scoped">
  #data-view{
    width: 100%;
    height: 100%;
    color: #fff;
  }
  #scroll-board {
    box-sizing: border-box;
    height: 98%;
    top: 1%;
  }
  /deep/ .el-tabs__item{
    height: auto !important;
    line-height: auto;
  }
  .el-tabs__item>img{
    width: 128px;
    height: auto;
    margin-bottom: 20px;
  }
  .el_div{
    border-left: 4px solid #409EFF;
    background: #F5F7FA;
    padding: 10px;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .pointArea{
    /* border: 2px solid rgba(6, 30, 93, 0.1); */
    width: 100%;
    height: 100%;
    position: relative;
  }
  .pointArea img{
    width: 100%;
    height: 100%;
  }
  .drag_div{
    position: absolute;
    width: auto;
    height: auto;
  }
  .drag_div:hover{
    z-index: 2;
  }
  .drag_move{
    cursor: move;
  }
  .points{
    border: 0;
    position: absolute;
  }
  @keyframes mylogo{
    0% {transform: scale(1.2,1.2);}
    25% {transform: scale(1,1);}
    50% {transform: scale(1.2,1.2);}
    75% {transform: scale(1,1);}
    100% {transform: scale(1.2,1.2);}
  }
</style>



// WEBPACK FOOTER //
// src/components/record/check_plan.vue